import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import ViewConciliacion from './ViewConciliacion';
import { store } from '../../store';
import { setConciliacion, setConciliacionInit, setSelConciliacion } from '../../actions';
import { ErrorToast, InfoToast, OkToast, CustomToast } from '../../components/specific/Toast';
import { useApiClient } from '../../clients/apiAuth';
import ModalConfirmarManifiesto from '../../components/specific/Conciliacion/Modales/ModalConfirmarManifiesto';
import ModalTarifasServicio from '../../components/specific/Conciliacion/Modales/ModalTarifasServicio';

const Conciliacion = (props) => {
  const [uploadFile, setUploadFile] = useState(false);
  const [loadingTables, setLoadingTables] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [selectedProcess, setSelectedProcess] = useState(null);
  const [detailFilter, setDetailFilter] = useState('all');
  const [detailRows, setDetailRows] = useState([]);
  const [detailCounts, setDetailCounts] = useState({ all: 0, valid: 0, invalid: 0 });
  const [selectedTab, setSelectedTab] = useState(1);
  const [loteFilters, setLoteFilters] = useState({ fechaInicio: '', fechaFin: '' });
  const [lotes, setLotes] = useState([]);
  const [lotesLoading, setLotesLoading] = useState(false);
  const [selectedLoteId, setSelectedLoteId] = useState('');
  const [takeoffFilters, setTakeoffFilters] = useState({ reporte: '', estado: '' });
  const [takeoffRows, setTakeoffRows] = useState([]);
  const [takeoffLoading, setTakeoffLoading] = useState(false);
  const [takeoffPagination, setTakeoffPagination] = useState(null);
  const [takeoffPage, setTakeoffPage] = useState(1);
  const [takeoffQuery, setTakeoffQuery] = useState(null);
  const [takeoffDetail, setTakeoffDetail] = useState(null);
  const [takeoffDetailOpen, setTakeoffDetailOpen] = useState(false);
  const [takeoffDetailLoading, setTakeoffDetailLoading] = useState(false);
  const [takeoffUpdating, setTakeoffUpdating] = useState({});
  const [takeoffFinalizing, setTakeoffFinalizing] = useState({});
  const [isConfirmarManifiestoOpen, setIsConfirmarManifiestoOpen] = useState(false);
  const [manifiestoVehiculo, setManifiestoVehiculo] = useState(null);
  const [manifiestoSolicitud, setManifiestoSolicitud] = useState(null);
  const [isTarifasOpen, setIsTarifasOpen] = useState(false);
  const [tarifasVehiculo, setTarifasVehiculo] = useState(null);
  const [tarifasSolicitud, setTarifasSolicitud] = useState(null);
  const [tarifasReporte, setTarifasReporte] = useState(null);
  const { get, DELETE, patch, put } = useApiClient();

  const getValidoValue = (row) => row?.VALIDO ?? row?.valido ?? row?.is_valid ?? row?.valid;

  const buildDetailCounts = (rows) => {
    let valid = 0;
    let invalid = 0;
    rows.forEach((row) => {
      const valido = getValidoValue(row);
      if (valido === 0 || valido === '0' || valido === false) {
        invalid += 1;
        return;
      }
      if (valido === 1 || valido === '1' || valido === true) {
        valid += 1;
      }
    });
    return { all: rows.length, valid, invalid };
  };

  const updateDetailCounts = (filter, rows) => {
    if (filter === 'all') {
      setDetailCounts(buildDetailCounts(rows));
      return;
    }
    if (filter === 'valid' || filter === 'invalid') {
      setDetailCounts((prev) => ({ ...prev, [filter]: rows.length }));
    }
  };

  const extractList = (result) => {
    if (Array.isArray(result?.data)) {
      return result.data;
    }
    if (Array.isArray(result?.data?.data)) {
      return result.data.data;
    }
    if (Array.isArray(result?.detalles)) {
      return result.detalles;
    }
    if (Array.isArray(result?.data?.detalles)) {
      return result.data.detalles;
    }
    if (Array.isArray(result)) {
      return result;
    }
    return [];
  };

  const normalizeListResponse = (result) => {
    if (result?.status) {
      return result;
    }
    const data = extractList(result);
    return {
      status: 200,
      data,
      pagination: result?.pagination || result?.meta || null,
    };
  };

  const parsePaginationNumber = (value) => {
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const normalizePagination = (result) => {
    const source =
      result?.pagination || result?.meta || result?.data?.pagination || result?.data?.meta || result;
    if (!source) {
      return null;
    }
    const currentPage = parsePaginationNumber(source.currentPage ?? source.current_page);
    const totalPages = parsePaginationNumber(
      source.totalPages ?? source.total_pages ?? source.lastPage ?? source.last_page
    );
    const totalRecords = parsePaginationNumber(source.totalRecords ?? source.total);
    if (currentPage === null || totalPages === null) {
      return null;
    }
    return {
      currentPage,
      totalPages,
      totalRecords: totalRecords ?? 0,
    };
  };

  const getTakeoffReporte = (row) =>
    row?.REPORTE ?? row?.reporte ?? row?.NO_REPORTE ?? row?.reporte_numero ?? row?.reporteNumero ?? '';

  const canFinalizarTakeoff = (row) => {
    const vehiculos = row?.solicitud?.vehiculos || [];

    if (vehiculos.length === 0) {
      ErrorToast('Error: ', 'No hay vehículos en la solicitud.');
      return false;
    }

    const withoutManifiesto = vehiculos.filter((v) => {
      const estado = v?.SOLICITUD_VEHICULO_MANIFIESTO_ESTADO ?? v?.MANIFIESTO_ESTADO ?? 0;
      return Number(estado) < 2;
    });

    if (withoutManifiesto.length > 0) {
      ErrorToast('Error: ', 'Todos los vehículos deben tener datos de manifiesto confirmados.');
      return false;
    }

    return true;
  };

  const buildTakeoffRoute = (query, page = 1) => {
    const params = new URLSearchParams();
    if (query?.reporte) {
      params.set('reporte', query.reporte);
    } else if (query?.loteId) {
      params.set('lote_id', query.loteId);
    }
    if (query?.estado !== undefined && query?.estado !== null && query?.estado !== '') {
      params.set('estado', query.estado);
    }
    if (query?.fechaInicio) {
      params.set('fecha_inicio', query.fechaInicio);
    }
    if (query?.fechaFin) {
      params.set('fecha_fin', query.fechaFin);
    }
    params.set('per_page', query?.perPage || 50);
    params.set('page', page);
    return `/takeoff?${params.toString()}`;
  };

  const getTakeoffImports = async () => {
    setLoadingTables(true);
    try {
      const result = await get('/takeoffImports?per_page=20');
      const normalized = normalizeListResponse(result);
      store.dispatch(setConciliacion(normalized));
    } catch (error) {
      ErrorToast('Error', 'No se pudo cargar los procesos.');
    } finally {
      setLoadingTables(false);
    }
  };

  const handleEdit = (obj) => {
    store.dispatch(setSelConciliacion(obj));
    InfoToast({ title: 'Edicion', message: 'pendiente de endpoint.' });
  };

  const deleteProcess = async (rowID) => {
    if (!rowID) {
      return;
    }
    try {
      const result = await DELETE(`/takeoffImports/${rowID}`);
      if (result?.success || String(result?.status || '').startsWith('2')) {
        const deletedDetails = result?.deleted_detalles;
        const message = deletedDetails ? `Proceso eliminado (${deletedDetails} detalles).` : 'Proceso eliminado.';
        OkToast({ message });
        getTakeoffImports();
        return;
      }
      ErrorToast('Error', result?.message || 'No se pudo eliminar el proceso.');
    } catch (error) {
      ErrorToast('Error', 'No se pudo eliminar el proceso.');
    }
  };

  const handleDelete = (rowID) => {
    toast((t) => (
      <span className="flex gap-2">
        <b>Seguro quiere eliminar conciliacion?</b>
        <button
          className="rounded-full border px-2 hover:bg-gray-300 hover:text-gray-500 "
          onClick={() => {
            toast.dismiss(t.id);
            deleteProcess(rowID);
          }}>
          Borrar
        </button>
        <button
          className="rounded-full border px-2 hover:bg-gray-300 hover:text-gray-500"
          onClick={() => toast.dismiss(t.id)}>
          Cancelar
        </button>
      </span>
    ));
  };

  const buildDetailsUrl = (processId, filter) => {
    const base = `/takeoffImports/${processId}/detalles?per_page=0`;
    if (filter === 'valid') {
      return `${base}&valido=1`;
    }
    if (filter === 'invalid') {
      return `${base}&valido=0`;
    }
    return base;
  };

  const getProcessDetails = async (processId, filter = 'all') => {
    if (!processId) {
      return;
    }
    setDetailsLoading(true);
    try {
      const result = await get(buildDetailsUrl(processId, filter));
      const rows = extractList(result);
      setDetailRows(rows);
      updateDetailCounts(filter, rows);
    } catch (error) {
      ErrorToast('Error', 'No se pudo cargar los detalles.');
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleShowDetails = (process) => {
    const processId = process?.id || process?.ID || process?.TAKEOFF_IMPORT_ID;
    setSelectedProcess(process);
    setDetailsModal(true);
    setDetailFilter('all');
    setDetailCounts({ all: 0, valid: 0, invalid: 0 });
    getProcessDetails(processId, 'all');
  };

  const handleDetailFilterChange = (filter) => {
    setDetailFilter(filter);
    const processId = selectedProcess?.id || selectedProcess?.ID || selectedProcess?.TAKEOFF_IMPORT_ID;
    getProcessDetails(processId, filter);
  };

  const handleCloseDetails = () => {
    setDetailsModal(false);
    setSelectedProcess(null);
    setDetailRows([]);
    setDetailCounts({ all: 0, valid: 0, invalid: 0 });
  };

  const handleRefreshDetails = () => {
    const processId = selectedProcess?.id || selectedProcess?.ID || selectedProcess?.TAKEOFF_IMPORT_ID;
    if (!processId) {
      return;
    }
    getProcessDetails(processId, detailFilter);
  };

  const handleTabClick = (tabId) => {
    setSelectedTab(tabId);
  };

  const handleLoteFilterChange = (field, value) => {
    setLoteFilters((prev) => ({ ...prev, [field]: value }));
  };

  const getTakeoffLotes = async (filters = loteFilters) => {
    setLotesLoading(true);
    try {
      const hasDateRange = Boolean(filters?.fechaInicio && filters?.fechaFin);
      const route = hasDateRange
        ? `/takeoff/lotes?fecha_inicio=${filters.fechaInicio}&fecha_fin=${filters.fechaFin}`
        : '/takeoff/lotes';
      const result = await get(route);
      const list = Array.isArray(result) ? result : extractList(result);
      setLotes(list);

      if (list.length === 1) {
        const loteId = list[0]?.LOTE_ID ?? list[0]?.lote_id ?? '';
        if (loteId) {
          setSelectedLoteId(loteId);
          const query = { loteId, perPage: 50 };
          setTakeoffQuery(query);
          getTakeoffList(query, 1);
        }
      }
    } catch (error) {
      ErrorToast('Error', 'No se pudieron cargar los lotes.');
    } finally {
      setLotesLoading(false);
    }
  };

  const getTakeoffList = async (query, page = 1) => {
    if (!query) {
      return;
    }
    setTakeoffLoading(true);
    setTakeoffPage(page);
    try {
      const result = await get(buildTakeoffRoute(query, page));
      const rows = extractList(result);
      setTakeoffRows(rows);
      setTakeoffPagination(normalizePagination(result));
    } catch (error) {
      ErrorToast('Error', 'No se pudieron cargar los detalles de takeoff.');
    } finally {
      setTakeoffLoading(false);
    }
  };

  const refreshTakeoffList = () => {
    if (!takeoffQuery) {
      return;
    }
    getTakeoffList(takeoffQuery, takeoffPage);
  };

  const handleSelectLote = (loteId) => {
    setSelectedLoteId(loteId);
    setTakeoffFilters((prev) => ({ ...prev, reporte: '' }));
    if (!loteId) {
      setTakeoffRows([]);
      setTakeoffPagination(null);
      setTakeoffQuery(null);
      return;
    }
    const query = {
      loteId,
      estado: takeoffFilters.estado || '',
      perPage: 50,
    };
    setTakeoffQuery(query);
    getTakeoffList(query, 1);
  };

  const handleTakeoffFilterChange = (field, value) => {
    setTakeoffFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleTakeoffSearch = () => {
    const reporte = takeoffFilters.reporte?.trim();
    const estado = takeoffFilters.estado;
    let query = null;

    if (reporte) {
      query = { reporte, perPage: 50 };
      setSelectedLoteId('');
    } else if (selectedLoteId) {
      query = { loteId: selectedLoteId, estado, perPage: 50 };
    } else if (estado !== '' || loteFilters.fechaInicio || loteFilters.fechaFin) {
      if (!loteFilters.fechaInicio || !loteFilters.fechaFin) {
        InfoToast({ title: 'Filtros', message: 'Seleccione un rango de fechas.' });
        return;
      }
      setSelectedLoteId('');
      query = {
        estado,
        fechaInicio: loteFilters.fechaInicio,
        fechaFin: loteFilters.fechaFin,
        perPage: 50,
      };
    }

    if (!query) {
      InfoToast({ title: 'Filtros', message: 'Seleccione lote, reporte o estado para buscar.' });
      return;
    }

    setTakeoffQuery(query);
    getTakeoffList(query, 1);
  };

  const handleTakeoffClearFilters = () => {
    setTakeoffFilters({ reporte: '', estado: '' });
    setSelectedLoteId('');
    setTakeoffRows([]);
    setTakeoffPagination(null);
    setTakeoffQuery(null);
    setTakeoffPage(1);
  };

  const handleTakeoffNextPage = (page) => {
    if (!takeoffQuery || !takeoffPagination) {
      return;
    }
    const totalPages = takeoffPagination.totalPages || 0;
    const targetPage = page ? page : takeoffPage + 1;
    if (!page && targetPage > totalPages) {
      return;
    }
    getTakeoffList(takeoffQuery, targetPage);
  };

  const handleTakeoffPreviusPage = () => {
    if (!takeoffQuery || takeoffPage <= 1) {
      return;
    }
    getTakeoffList(takeoffQuery, takeoffPage - 1);
  };

  const handleShowTakeoffDetail = async (reporte) => {
    if (!reporte) {
      return;
    }
    setTakeoffDetailOpen(true);
    setTakeoffDetail(null);
    setTakeoffDetailLoading(true);
    try {
      const result = await get(`/takeoff/reporte/${reporte}`);
      setTakeoffDetail(result?.data ?? result);
    } catch (error) {
      ErrorToast('Error', 'No se pudo cargar el detalle del reporte.');
      setTakeoffDetail(null);
    } finally {
      setTakeoffDetailLoading(false);
    }
  };

  const handleCloseTakeoffDetail = () => {
    setTakeoffDetailOpen(false);
    setTakeoffDetail(null);
    setTakeoffDetailLoading(false);
  };

  const handleOpenManifiesto = (vehiculo, solicitud) => {
    setManifiestoVehiculo(vehiculo || null);
    setManifiestoSolicitud(solicitud || null);
    setIsConfirmarManifiestoOpen(true);
  };

  const handleCloseManifiesto = () => {
    setIsConfirmarManifiestoOpen(false);
    setManifiestoVehiculo(null);
    setManifiestoSolicitud(null);
  };

  const handleManifiestoSuccess = () => {
    refreshTakeoffList();
    handleCloseManifiesto();
  };

  const handleOpenTarifas = (vehiculo, solicitud, reporte) => {
    setTarifasVehiculo(vehiculo || null);
    setTarifasSolicitud(solicitud || null);
    setTarifasReporte(reporte || null);
    setIsTarifasOpen(true);
  };

  const handleCloseTarifas = () => {
    setIsTarifasOpen(false);
    setTarifasVehiculo(null);
    setTarifasSolicitud(null);
    setTarifasReporte(null);
  };

  const updateTakeoffRowEstado = (reporte, estado) => {
    setTakeoffRows((prev) =>
      prev.map((row) => {
        const rowReporte = getTakeoffReporte(row);
        if (String(rowReporte) === String(reporte)) {
          return { ...row, ESTADO: estado, estado };
        }
        return row;
      })
    );
  };

  const handleUpdateTakeoffEstado = async (reporte, estado) => {
    if (!reporte) {
      return;
    }
    setTakeoffUpdating((prev) => ({ ...prev, [reporte]: true }));
    try {
      const result = await patch(`/takeoff/reporte/${reporte}/estado`, { estado: Number(estado) });
      if (result?.success === false || (result?.status && !String(result.status).startsWith('2'))) {
        ErrorToast('Error', result?.message || 'No se pudo actualizar el estado.');
        return;
      }
      OkToast({ message: result?.message || 'Estado actualizado.' });
      updateTakeoffRowEstado(reporte, estado);
    } catch (error) {
      ErrorToast('Error', 'No se pudo actualizar el estado.');
    } finally {
      setTakeoffUpdating((prev) => ({ ...prev, [reporte]: false }));
    }
  };

  const finalizarSolicitud = async (id) => {
    // Show loading toast and set loading state
    const loadingToastId = toast.loading('Finalizando solicitud... Esto puede tardar hasta 20 segundos.');
    setTakeoffFinalizing((prev) => ({ ...prev, [id]: true }));

    try {
      const result = await put(
        `/solicitud/${id}?EDITAR_SOLO_FINALIZAR=1`,
        {
          json: JSON.stringify({
            SOLICITUD_APROBADA: "6",
            TERCERO_ID: props.auth.data.user.TERCERO_ID
          }),
        },
        'application/json'
      );

      // Dismiss loading toast
      toast.dismiss(loadingToastId);

      if (String(result.status).substr(0, 1) !== '2') {
        CustomToast({ result });
      } else {
        OkToast({ result, message: 'Solicitud Finalizada!' });
        // Update the row's SOLICITUD_APROBADA to 6 (keep row visible)
        setTakeoffRows((prev) =>
          prev.map((row) => {
            if (row?.solicitud?.SOLICITUD_ID === id) {
              return {
                ...row,
                solicitud: {
                  ...row.solicitud,
                  SOLICITUD_APROBADA: 6
                }
              };
            }
            return row;
          })
        );
      }
    } catch (error) {
      // Dismiss loading toast
      toast.dismiss(loadingToastId);
      ErrorToast('Error:', error);
    } finally {
      setTakeoffFinalizing((prev) => ({ ...prev, [id]: false }));
    }
  };

  const handleFinalizarTakeoff = (row) => {
    const solicitudId = row?.solicitud?.SOLICITUD_ID;
    const otInterna = row?.solicitud?.SOLICITUD_CONSECUTIVO_INT || 'N/A';

    if (!solicitudId) {
      ErrorToast('Error: ', 'No se encontró el ID de la solicitud.');
      return;
    }

    if (!canFinalizarTakeoff(row)) {
      return;
    }

    toast((t) => (
      <span className="flex gap-2">
        <b>¿Está seguro que desea finalizar la solicitud {otInterna}?</b>
        <button
          className="rounded-full border px-2 hover:bg-gray-300 hover:text-gray-500"
          onClick={() => {
            toast.dismiss(t.id);
            finalizarSolicitud(solicitudId);
          }}>
          Si
        </button>
        <button
          className="rounded-full border px-2 hover:bg-gray-300 hover:text-gray-500"
          onClick={() => toast.dismiss(t.id)}>
          No
        </button>
      </span>
    ));
  };

  const deleteTakeoffReporte = async (reporte) => {
    if (!reporte) {
      return;
    }
    try {
      const result = await DELETE(`/takeoff/reporte/${reporte}`);
      if (result?.success || String(result?.status || '').startsWith('2')) {
        OkToast({ message: result?.message || 'Reporte eliminado.' });
        setTakeoffRows((prev) => prev.filter((row) => String(getTakeoffReporte(row)) !== String(reporte)));
        return;
      }
      ErrorToast('Error', result?.message || 'No se pudo eliminar el reporte.');
    } catch (error) {
      ErrorToast('Error', 'No se pudo eliminar el reporte.');
    }
  };

  const handleDeleteTakeoffReporte = (reporte) => {
    toast((t) => (
      <span className="flex gap-2">
        <b>Seguro quiere eliminar el reporte {reporte}?</b>
        <button
          className="rounded-full border px-2 hover:bg-gray-300 hover:text-gray-500"
          onClick={() => {
            toast.dismiss(t.id);
            deleteTakeoffReporte(reporte);
          }}>
          Borrar
        </button>
        <button
          className="rounded-full border px-2 hover:bg-gray-300 hover:text-gray-500"
          onClick={() => toast.dismiss(t.id)}>
          Cancelar
        </button>
      </span>
    ));
  };

  const deleteTakeoffLote = async (loteId) => {
    if (!loteId) {
      return;
    }
    try {
      const result = await DELETE(`/takeoff/lote/${loteId}`);
      if (result?.success || String(result?.status || '').startsWith('2')) {
        OkToast({ message: result?.message || 'Lote eliminado.' });
        setSelectedLoteId('');
        setTakeoffRows([]);
        setTakeoffPagination(null);
        setTakeoffQuery(null);
        getTakeoffLotes();
        return;
      }
      ErrorToast('Error', result?.message || 'No se pudo eliminar el lote.');
    } catch (error) {
      ErrorToast('Error', 'No se pudo eliminar el lote.');
    }
  };

  const handleDeleteTakeoffLote = () => {
    if (!selectedLoteId) {
      return;
    }
    toast((t) => (
      <span className="flex gap-2">
        <b>Seguro quiere eliminar el lote {selectedLoteId}?</b>
        <button
          className="rounded-full border px-2 hover:bg-gray-300 hover:text-gray-500"
          onClick={() => {
            toast.dismiss(t.id);
            deleteTakeoffLote(selectedLoteId);
          }}>
          Borrar
        </button>
        <button
          className="rounded-full border px-2 hover:bg-gray-300 hover:text-gray-500"
          onClick={() => toast.dismiss(t.id)}>
          Cancelar
        </button>
      </span>
    ));
  };

  useEffect(() => {
    store.dispatch(setConciliacionInit());
    getTakeoffImports();
  }, []);

  useEffect(() => {
    if (selectedTab === 2 && lotes.length === 0) {
      getTakeoffLotes();
    }
  }, [selectedTab]);

  return (
    <>
      <ViewConciliacion
        modal={{ uploadFile, setUploadFile }}
        tabs={{ selectedTab, handleTabClick }}
        actions={{
          loadingTables,
          handleEdit,
          handleDelete,
          handleShowDetails,
          handleRefresh: getTakeoffImports,
        }}
        details={{
          detailsModal,
          detailsLoading,
          selectedProcess,
          detailFilter,
          detailRows,
          detailCounts,
          handleDetailFilterChange,
          handleCloseDetails,
          handleRefreshDetails,
        }}
        takeoff={{
          data: {
            lotes,
            lotesLoading,
            selectedLoteId,
            loteFilters,
            takeoffFilters,
            takeoffRows,
            takeoffLoading,
            takeoffPagination,
            takeoffPage,
            takeoffDetail,
            takeoffDetailOpen,
            takeoffDetailLoading,
            takeoffUpdating,
            takeoffFinalizing,
          },
          actions: {
            handleLoteFilterChange,
            handleLoadLotes: getTakeoffLotes,
            handleSelectLote,
            handleTakeoffFilterChange,
            handleTakeoffSearch,
            handleTakeoffClearFilters,
            handleShowTakeoffDetail,
            handleCloseTakeoffDetail,
            handleUpdateTakeoffEstado,
            handleDeleteTakeoffReporte,
            handleDeleteTakeoffLote,
            handleOpenManifiesto,
            handleOpenTarifas,
            handleFinalizarTakeoff,
          },
          pager: {
            handleNextPage: handleTakeoffNextPage,
            handlePreviusPage: handleTakeoffPreviusPage,
          },
        }}
      />

      <ModalConfirmarManifiesto
        isOpen={isConfirmarManifiestoOpen}
        onClose={handleCloseManifiesto}
        vehiculo={manifiestoVehiculo}
        solicitud={manifiestoSolicitud}
        auth={props.auth}
        onSuccess={handleManifiestoSuccess}
      />

      <ModalTarifasServicio
        isOpen={isTarifasOpen}
        onClose={handleCloseTarifas}
        vehiculo={tarifasVehiculo}
        solicitud={tarifasSolicitud}
        reporte={tarifasReporte}
      />
    </>
  );
};

const mapStateToProps = function (state) {
  return {
    conciliacion: state.conciliacion,
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(Conciliacion);
